import React, { useState, useEffect } from "react";
import Login from "./Login/login";
import Register from "./register/register";
import SsoLogin from "./SSO/SsoLogin";  // Importiere dein SSO Login Component
import "./signup.css";
import axios from 'axios'; // Für API-Aufrufe

const AuthContainer = () => {
  const [selectedOption, setSelectedOption] = useState("login");
  const [userExists, setUserExists] = useState(false); // Status, ob Benutzer existiert

  // Funktion zur Überprüfung, ob ein Benutzer existiert
  const checkIfUserExists = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/check-user-exists`);
      setUserExists(response.data.exists); // Setzt den Status basierend auf dem Ergebnis
    } catch (error) {
      console.error("Fehler beim Überprüfen der Benutzer:", error);
    }
  };

  useEffect(() => {
    // Überprüfen, ob ein Benutzer existiert, sobald die Komponente geladen wird
    checkIfUserExists();
  }, []);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  return (
    <section className="container Bottom">
      <div className="auth-container">
        <div className="auth-buttons">
          <button
            className={`auth-button btn-gl1 ${
              selectedOption === "login" ? "active" : ""
            }`}
            onClick={() => handleOptionChange("login")}
          >
            Login
          </button>

          {/* Nur anzeigen, wenn kein Benutzer in der Datenbank existiert */}
          {!userExists && (
            <button
              className={`auth-button btn-gl2 ${
                selectedOption === "register" ? "active" : ""
              }`}
              onClick={() => handleOptionChange("register")}
            >
              Register
            </button>
          )}

          <button
            className={`auth-button btn-gl3 ${
              selectedOption === "sso" ? "active" : ""
            }`}
            onClick={() => handleOptionChange("sso")}
          >
            SSO Login
          </button>
        </div>

        <div className="auth-content Register">
          {selectedOption === "login" && <Login />}
          {selectedOption === "register" && <Register />}
          {selectedOption === "sso" && <SsoLogin />}
        </div>
      </div>
    </section>
  );
};

export default AuthContainer;
